import LogoType from "../FadeHeader/Components/LogoType/LogoType";
import React from "react";
import QuickSearch from "../FadeHeader/Components/QuickSearch";
import * as styles from "./base.scss";
import MiniCartButton from "../FadeHeader/Components/Buttons/MiniCart/MiniCartButton";
import DeliveryDatesButton from "../FadeHeader/Components/Buttons/DeliveryDates/DeliveryDatesButton";
import LoginButton from "../FadeHeader/Components/Buttons/MyMenigo/LoginButton";
import ProfileDropdown from "./RightMenuButton";
import MyMenigoIcon from "../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon";
import connect from "Shared/connect";
import DesktopMenu from "SiteLayout/MainMenu/DesktopMenu";
import MiniCart from "SiteLayout/MiniCart";
import Main from "Shared/PageLayout";
import Overlay from "Shared/Overlay";
import miniCartIsDisabled from "SiteLayout/MiniCart/is-disabled-selector";
import classnames from "classnames";
import { LARGE, MEDIUM, SMALL } from "Shared/breakpoints";
import HamburgerButton from "../HamburgerButton";
import MobileQuickSearch from "../FadeHeader/Components/QuickSearch/Mobile";
import MegaMenuButton from "./MegaMenuButton";
import RightMenu from "SiteLayout/RightMenu/RightMenuContainer";
class MainHeader extends React.PureComponent {
    constructor(props) {
        super(props);
        this.itemCssClass = (url) => {
            return url === this.props.currentPage.url ||
                (this.props.currentPage.url + "/").indexOf(url) == 0
                ? classnames(styles.hoverEffect, styles.clicked)
                : styles.hoverEffect;
        };
        this.itemCssClassForFavoriteList = (url) => {
            return url === this.props.currentPage.url ||
                (this.props.currentPage.url + "/").indexOf(url) == 0
                ? classnames(styles.headerFavoriteButton, styles.clicked)
                : styles.headerFavoriteButton;
        };
        this.state = {
            isSticky: true,
            isVisible: true,
            clickedContentLinkUrl: null,
        };
    }
    render() {
        const isDesktop = this.props.currentBreakpoint >= LARGE;
        const isMobile = this.props.currentBreakpoint < SMALL;
        const isLoggedOut = !this.props.isLoggedIn;
        const shouldShowProfile = this.props.currentBreakpoint > MEDIUM;
        return (React.createElement("header", null,
            React.createElement(Overlay, { enabled: this.props.isOpen },
                React.createElement("div", { className: classnames(styles.base, styles.sticky) },
                    React.createElement("div", { className: styles.content },
                        React.createElement(LogoType, { siteUrl: this.props.mainMenu.siteUrl, className: styles.logo }),
                        !isMobile && React.createElement(QuickSearch, null),
                        React.createElement("div", { className: styles.headerControls },
                            isDesktop && React.createElement(MegaMenuButton, null),
                            isDesktop &&
                                this.props.mainMenu.rightContentLinks.map((item, index) => (React.createElement("div", { className: styles.contentLinks, key: "right" + index },
                                    React.createElement("li", null,
                                        React.createElement("a", { className: this.itemCssClass(item.url), href: item.url }, item.displayName)))))),
                        React.createElement("div", { className: styles.buttonsWrapper },
                            this.props.miniCartIsOpen && (React.createElement("div", { className: styles.miniCartWrapper },
                                React.createElement(Main, null,
                                    React.createElement(MiniCart, null)))),
                            this.props.currentBreakpoint < SMALL && (React.createElement("div", { className: styles.searchMobileIcon },
                                React.createElement(MobileQuickSearch, null))),
                            this.props.isLoggedIn && (React.createElement("div", null,
                                React.createElement(DeliveryDatesButton, null))),
                            !this.props.miniCartIsDisabled && !!this.props.isLoggedIn && (React.createElement("div", { className: styles.inlineButtons },
                                React.createElement(MiniCartButton, null),
                                !isMobile && this.props.favoritePage && (React.createElement("a", { "data-opti-id": "header-favorite-button", className: this.itemCssClassForFavoriteList(this.props.favoritePage), href: this.props.favoritePage },
                                    React.createElement(MyMenigoIcon, { name: "headerFavorite" }))))),
                            !isLoggedOut && (React.createElement("div", { "data-opti-id": "header-my-menigo-button", className: styles.profileDropdownWrapper }, shouldShowProfile && React.createElement(ProfileDropdown, null))),
                            isLoggedOut && (React.createElement("div", { className: styles.loggedOutButttons },
                                !isMobile &&
                                    this.props.mainMenu.topContentLinks.map((item, index) => (React.createElement("div", { className: styles.contentLinks, key: "top" + index, "data-opti-id": "header-become-customer" },
                                        React.createElement("li", null,
                                            React.createElement("a", { href: item.url }, item.displayName))))),
                                React.createElement(LoginButton, null)))),
                        React.createElement("div", { className: styles.mainMenuWrapper },
                            " ",
                            React.createElement(DesktopMenu, null),
                            " "),
                        this.props.currentBreakpoint < LARGE && (React.createElement("div", null,
                            React.createElement(HamburgerButton, null))),
                        React.createElement(RightMenu, null))))));
    }
}
export default connect((state) => {
    var _a;
    return ({
        currentPage: state.currentPage,
        isLoggedIn: state.currentUser.isLoggedIn,
        mainMenu: state.mainMenu,
        favoritePage: (_a = state.appShellData.siteSettings.favoriteOverviewPage) === null || _a === void 0 ? void 0 : _a.url,
        isOpen: state.mainMenu.isOpen ||
            (state.quickSearch.isOpen &&
                state.quickSearch.completionsLists !== null) ||
            state.mainMenu.rightMenuIsOpen,
        miniCartIsOpen: state.miniCart.isOpen && !miniCartIsDisabled(state),
        miniCartIsDisabled: miniCartIsDisabled(state),
        currentBreakpoint: state.currentBreakpoint,
    });
})(MainHeader);
